// import packages
import React, {useEffect, useState} from "react";
import {connect} from "react-redux";

// Import assets
import "./homepage.scss"

// Import Components
import MainSlider from "./slider/MainSlider";
import About from "./about/About";
import HomeFilterBlock from "../../components/HomeFilterBlock";
// Import utils
import {getPropsFromState} from "../../redux/mapStateToProps";
import ProfitableOffer from "./profitableOffer/ProfitableOffer";
import ContactBlock from "../../components/contactBlock/ContactBlock";
import Subscription from "../../components/subscription/Subscription";
import HomePartner from "./partners/HomePartner";
import Buildings from "./buildings/Buildings";
import HomeProjects from "./projects/HomeProjects";
import HomeWorks from "./work/HomeWorks";
import HomeServices from "./services/HomeServices";

function Homepage(props) {
    return <>
            <div className={'Homepage'}>
               <div className={'sliderImg-Wrapper'}>
                   <MainSlider/>
               </div>
                <Buildings/>
                <About/>
                <div className={'services_wrapper'}>
                    <HomeServices/>
                </div>
                <HomeWorks/>
                <HomeProjects/>
                <HomePartner/>
                {/*<ContactBlock/>*/}
                {/*<Subscription/>*/}
            </div>
    </>
}

const mapStateToProps = (state) => getPropsFromState(state, []);

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Homepage);
